var _path, _path2, _path3, _path4, _g, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.75C3.89543 0.75 3 1.64543 3 2.75V21.25C3 22.3546 3.89543 23.25 5 23.25H19C20.1046 23.25 21 22.3546 21 21.25V6.75L15 0.75H5Z",
    fill: "#426AE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.75C3.89543 0.75 3 1.64543 3 2.75V21.25C3 22.3546 3.89543 23.25 5 23.25H19C20.1046 23.25 21 22.3546 21 21.25V6.75L15 0.75H5Z",
    fill: "#426AE6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_113_1917",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 18,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.75C3.89543 0.75 3 1.64543 3 2.75V21.25C3 22.3546 3.89543 23.25 5 23.25H19C20.1046 23.25 21 22.3546 21 21.25V6.75L15 0.75H5Z",
    fill: "#426AE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.75C3.89543 0.75 3 1.64543 3 2.75V21.25C3 22.3546 3.89543 23.25 5 23.25H19C20.1046 23.25 21 22.3546 21 21.25V6.75L15 0.75H5Z",
    fill: "#426AE6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_113_1917)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0.75H19C20.1046 0.75 21 1.64543 21 2.75V6.75H17C15.8954 6.75 15 5.85457 15 4.75V0.75Z",
    fill: "#426AE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0.75H19C20.1046 0.75 21 1.64543 21 2.75V6.75H17C15.8954 6.75 15 5.85457 15 4.75V0.75Z",
    fill: "white"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.35742 15.75V11.5078H8.02148C8.98828 11.5078 9.53906 12.0996 9.53906 12.9375C9.53906 13.7871 8.97656 14.3672 7.99805 14.3672H7.23633V15.75H6.35742ZM7.23633 13.6582H7.85742C8.37891 13.6582 8.63086 13.3652 8.63086 12.9375C8.63086 12.5156 8.37891 12.2285 7.85742 12.2285H7.23633V13.6582ZM11.5898 15.75H10.0957V11.5078H11.6074C12.8848 11.5078 13.6641 12.3047 13.6641 13.623C13.6641 14.9531 12.8848 15.75 11.5898 15.75ZM10.9746 14.9941H11.5547C12.3633 14.9941 12.7852 14.5723 12.7852 13.623C12.7852 12.6797 12.3633 12.2637 11.5605 12.2637H10.9746V14.9941ZM14.3027 15.75V11.5078H17.0977V12.2344H15.1816V13.2656H16.916V13.9922H15.1816V15.75H14.3027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0835a722a457caa8ed23adeb98f71cbe.svg";
export { ForwardRef as ReactComponent };